import AttributeEditModal from '../../Modals/AttributeModals/AttributeEditModal'
import CircuitEditModal from '../../Modals/CircuitModals/CircuitEditModal'
import UpdateContentCategoryModal from '../../Modals/ContentModals/UpdateContentCategoryModal'
import UpdateGroupForm from '../../Modals/DeviceModals/UpdateGroupForm'
import UpdateShadowForm from '../../Modals/DeviceModals/UpdateShadowForm'
import UpdateTypeForm from '../../Modals/DeviceModals/UpdateTypeForm'
import UpdateUserForm from '../../Modals/DeviceModals/UpdateUserForm'
import UpdateExperimentCategoryModal from '../../Modals/ExperimentModals/UpdateExperimentCategoryModal'

function UpdateTabContentModal({editData, updateProcess, item, setAction}: any) {
  if (updateProcess === 'Type') {
    return <UpdateTypeForm editData={editData} itemId={item.id} setAction={setAction} />
  } else if (updateProcess === 'Group') {
    return <UpdateGroupForm editData={editData} itemId={item.id} setAction={setAction} />
  } else if (updateProcess === 'User') {
    return <UpdateUserForm editData={editData} itemId={item.id} setAction={setAction} />
  } else if (updateProcess === 'Shadow') {
    return <UpdateShadowForm editData={editData} itemId={item.id} setAction={setAction} />
  } else if (updateProcess === 'Circuit') {
    return <CircuitEditModal editData={editData} setAction={setAction} />
  } else if (updateProcess === 'ECategory') {
    return <UpdateExperimentCategoryModal editData={editData} setAction={setAction} />
  } else if (updateProcess === 'Attribute') {
    return <AttributeEditModal editData={editData} setAction={setAction} />
  } else if (updateProcess === 'Category') {
    return <UpdateContentCategoryModal editData={editData} setAction={setAction} />
  }
  return <div></div>
}

export default UpdateTabContentModal
